'use client';

import { useRouter } from 'next/navigation';
import { PlusIcon } from '@heroicons/react/24/solid';
import Text from '@/components/ui/typography/text';
import Button from '@/components/ui/button';
import { Routes } from '@/config/routes';
import { useState, useEffect } from 'react';

export default function DashboardHero() {
  const router = useRouter();

  const [loggedUser, setLoggedUser] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const user = localStorage.getItem('loggedUser');
      if (user && !loggedUser) {
        // Only update if loggedUser is null/undefined
        setLoggedUser(JSON.parse(user));
      }
    }
  }, [loggedUser]); // Add loggedUser as a dependency

  return (
    <div className="mt-8 flex items-center justify-between lg:mt-12 2xl:mt-16">
      <div>
        {loggedUser ? (
          <>
            <Text tag="h3" className="text-xl">
              Hello, {loggedUser.name}
            </Text>
            <Text className="mt-2 text-sm text-gray lg:mt-3">
              @{loggedUser.username || 'unknown'}
            </Text>
          </>
        ) : (
          <Text tag="h3" className="text-xl">
            Hello, Guest
          </Text>
        )}
      </div>
      <div>
        <Button
          size="xl"
          rounded="pill"
          className="!p-2 capitalize text-white sm:rounded-md sm:!px-8 sm:!py-[10px]"
          onClick={() => router.push(Routes.public.addListing)}
        >
          <PlusIcon className="h-auto w-5 sm:mr-3" />
          <span className="hidden sm:block">Add listing</span>
        </Button>
      </div>
    </div>
  );
}
